import PropTypes from "prop-types";
import { Box, Button, ListItem, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const NavItem = (props) => {
    const { href, icon, title, tab, id, sidebarCollapse, ...others } = props;
    let active = tab === id;
    const navigate = useNavigate();

    const clickLink = () => {
        navigate(href, { replace: false });
    };
    return (
        <ListItem
            disableGutters
            sx={{
                display: "flex",
                mb: 0.5,
                py: 0,
            }}
            {...others}
        >
            <span onClick={clickLink} style={{ width: "100%" }}>
                <Tooltip
                    title={title}
                    // open
                    arrow
                    placement="right"
                    disableHoverListener={!sidebarCollapse}
                    slotProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #21315a",
                                color: "#352654",

                                padding: "4px",
                                textAlign: "center",
                            },
                        },
                        arrow: {
                            sx: {
                                border: "1px solid #21315a",
                                color: "#FFFFFF",
                                borderRight:"unset"
                            },
                        },
                    }}
                >
                    <Button
                        component="a"
                        startIcon={icon}
                        disableRipple
                        sx={{
                            backgroundColor: active && "rgba(255,255,255, 0.08)",
                            borderRadius: "4px",
                            color: active ? "white" : "neutral.300",
                            fontWeight: active && "fontWeightBold",
                            justifyContent: "flex-start",
                            textAlign: "left",
                            textTransform: "none",
                            width: "100%",
                            px: sidebarCollapse ? 2 : 4,
                            whiteSpace: "nowrap",

                            "& .MuiButton-startIcon": {
                                color: active ? "secondary.main" : "neutral.400",
                            },
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255, 0.08)",
                            },

                            ...(sidebarCollapse && {
                                minWidth: "unset",

                                "& .MuiButton-startIcon": {
                                    margin: 0,
                                    color: active ? "secondary.main" : "neutral.400",
                                },
                            }),
                        }}
                    >
                        <Box sx={{ flexGrow: 1 }}>{sidebarCollapse ? "" : title}</Box>
                    </Button>
                </Tooltip>
            </span>
        </ListItem>
    );
};

NavItem.propTypes = {
    href: PropTypes.string,
    icon: PropTypes.node,
    title: PropTypes.string,
    tab: PropTypes.string,
    id: PropTypes.string,
};
